// splitshire-v2 backend: no /api prefix, default port 3000
const dev = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL_DEV || process.env.REACT_APP_API_URL || 'http://localhost:3000'
};

const prod = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL_PROD || process.env.REACT_APP_API_URL || 'http://localhost:3000'
};

const test = {
  API_ENDPOINT_URL: '/api'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
